/* eslint-disable no-undef */
import mqtt from "mqtt";

export function connectMQTT() {
    let options = {
        reconnectPeriod: 10000,
        rejectUnauthorized: true,
        username: process.env.VUE_APP_MQTT_USER,
        password: process.env.VUE_APP_MQTT_PASSWORD
    };
    let client = null;

    try {
        client = mqtt.connect(process.env.VUE_APP_MQTT, options);
        client.setMaxListeners(10000);
    } catch (err) {
        console.error("Error creating vue mqtt instance", err);
    }
    return client;
}